import * as actionTypes from "../actionTypes";

const initialState = {
    podcastData: [],
    videoclipData: [],
    newsData: [],
    liveData: [],
};

const sancharReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_PODCAST:
            return { ...state, podcastData: payload };

        case actionTypes.SET_VIDEOCLIP:
            return { ...state, videoclipData: payload };

        case actionTypes.SET_NEWS:
            return { ...state, newsData: payload };

        case actionTypes.SET_LIVE:
            return { ...state, liveData: payload };

        default:
            return state;
    }
};

export default sancharReducer;